export default {
  customDetail: state => state.customDetail,
  customList: state => state.customList,
  doctorListData: state => state.doctorListData,
  projectList: state => state.projectList,
  customerApplyList: state => state.customerApplyList,
  customContacts: state => state.customContacts,
  customVisits: state => state.customVisits,
  customBusi: state => state.customBusi,
  customCompact: state => state.customCompact,
  hospitalLevel: state => state.hospitalLevel,
  customerFollowUp: state => state.customerFollowUp,
  doctorList: state => state.doctorList,
  operators: state => state.operators,
  customArchiveData: state => state.customArchiveData,
  customSalesman: state => state.customSalesman,
  finallyCustomData: state => state.finallyCustomData,
  refusedCustomData: state => state.refusedCustomData,
  governmentData: state => state.governmentData,
  busiLine: state => state.busiLine,
  investigationPerson: state => state.investigationPerson,
  governmentDetail: state => state.governmentDetail,
  projectData: state => state.projectData,
  proFollowData: state => state.proFollowData,
  teamList: state => state.teamList,
  projectDetailList: state => state.projectDetailList,
  // 保有量
  customerHoldBoolean: state => state.customerHoldBoolean,
  medicalCustomList: state => state.medicalCustomList,
  customType: state => state.customType,
};
